/**
 * Inspiration List Load More Functionality
 * ES6 JavaScript with async/await
 */

class InspirationList {
  constructor(section) {
    this.section = section;
    this.sectionId = section.dataset.sectionId;
    this.dataElement = document.getElementById(`inspiration-data-${this.sectionId}`);
    this.itemsContainer = document.getElementById(`inspiration-items-${this.sectionId}`);
    this.loadMoreBtn = document.getElementById(`load-more-btn-${this.sectionId}`);
    
    if (!this.dataElement || !this.itemsContainer) {
      return;
    }
    
    this.data = JSON.parse(this.dataElement.textContent);
    this.postsPerPage = this.data.postsPerPage;
    this.allItems = this.data.items;
    this.currentPage = 1;
    this.isLoading = false;
    
    this.init();
  }
  
  init() {
    if (!this.loadMoreBtn) {
      return;
    }
    
    this.loadMoreBtn.addEventListener('click', () => this.loadMore());
    this.updateButtonVisibility();
    this.applyGridPattern();
  }
  
  async loadMore() {
    if (this.isLoading) {
      return;
    }
    
    this.isLoading = true;
    this.loadMoreBtn.disabled = true;
    this.loadMoreBtn.textContent = 'LOADING...';
    
    // Simulate async operation (small delay for smooth UX)
    await new Promise(resolve => setTimeout(resolve, 300));
    
    const startIndex = this.currentPage * this.postsPerPage;
    const endIndex = startIndex + this.postsPerPage;
    const nextItems = this.allItems.slice(startIndex, endIndex);
    
    if (nextItems.length > 0) {
      this.renderItems(nextItems, startIndex);
      this.currentPage++;
    }
    
    this.isLoading = false;
    this.loadMoreBtn.disabled = false;
    this.loadMoreBtn.textContent = 'LOAD MORE';
    
    this.updateButtonVisibility();
    this.applyGridPattern();
  }
  
  renderItems(items, startIndex) {
    items.forEach((item, index) => {
      const itemElement = this.createItemElement(item, startIndex + index);
      this.itemsContainer.appendChild(itemElement);
      
      // Trigger animation after a small delay for staggered effect
      setTimeout(() => {
        itemElement.classList.add('inspiration-list__item--fade-in');
      }, index * 50);
    });
  }
  
  createItemElement(item, index) {
    const itemDiv = document.createElement('div');
    itemDiv.className = 'inspiration-list__item';
    itemDiv.dataset.itemIndex = index;

    // Optional link wrapper
    const linkWrapper = item.url ? document.createElement('a') : null;
    if (linkWrapper) {
      linkWrapper.className = 'inspiration-list__item-link';
      linkWrapper.href = item.url;
    }

    // Image container
    if (item.image) {
      const imageDiv = document.createElement('div');
      imageDiv.className = 'inspiration-list__item-image';
      imageDiv.style.backgroundImage = `url('${item.image}')`;
      
      const overlayDiv = document.createElement('div');
      overlayDiv.className = 'inspiration-list__item-overlay';
      
      imageDiv.appendChild(overlayDiv);
      if (linkWrapper) {
        linkWrapper.appendChild(imageDiv);
      } else {
        itemDiv.appendChild(imageDiv);
      }
    }
    
    // Content container
    const contentDiv = document.createElement('div');
    contentDiv.className = 'inspiration-list__item-content';
    
    // Collections (badges)
    if (item.collections && item.collections.length > 0) {
      const categoriesDiv = document.createElement('div');
      categoriesDiv.className = 'inspiration-list__item-categories';
      
      item.collections.forEach(category => {
        const categorySpan = document.createElement('span');
        categorySpan.className = 'inspiration-list__item-category';
        categorySpan.textContent = category;
        categoriesDiv.appendChild(categorySpan);
      });
      
      contentDiv.appendChild(categoriesDiv);
    }
    
    // Heading
    if (item.heading) {
      const titleH2 = document.createElement('h2');
      titleH2.className = 'inspiration-list__item-title';
      titleH2.textContent = item.heading;
      contentDiv.appendChild(titleH2);
    }
    
    if (linkWrapper) {
      linkWrapper.appendChild(contentDiv);
      itemDiv.appendChild(linkWrapper);
    } else {
      itemDiv.appendChild(contentDiv);
    }
    
    return itemDiv;
  }
  
  updateButtonVisibility() {
    if (!this.loadMoreBtn) {
      return;
    }
    
    const totalLoaded = this.currentPage * this.postsPerPage;
    const hasMore = totalLoaded < this.allItems.length;
    
    if (!hasMore) {
      this.loadMoreBtn.style.display = 'none';
    }
  }

  // Apply grid-area layout pattern (runs initially and after Load More)
  applyGridPattern() {
    const pattern = [
      [1, 1, 3, 3],
      [3, 1, 4, 2],
      [4, 1, 5, 2],
      [3, 2, 5, 3],
      [5, 1, 7, 2],
      [5, 2, 6, 3],
      [6, 2, 7, 3],
    ];
    const rowsPerBlock = 6;
    const items = this.itemsContainer.querySelectorAll('.inspiration-list__item');
    items.forEach((item, i) => {
      const block = Math.floor(i / 7);
      const index = i % 7;
      const [r1, c1, r2, c2] = pattern[index];
      const rowStart = r1 + rowsPerBlock * block;
      const rowEnd = r2 + rowsPerBlock * block;
      item.style.gridArea = `${rowStart} / ${c1} / ${rowEnd} / ${c2}`;
    });
  }
}

// Initialize on DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.inspiration-list[data-section-id]');
  
  sections.forEach(section => {
    new InspirationList(section);
  });
});

// Re-initialize on section load (for theme editor)
if (typeof Shopify !== 'undefined') {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.inspiration-list[data-section-id]');
    if (section) {
      new InspirationList(section);
    }
  });
}

const pattern = [
  [1, 1, 3, 3],
  [3, 1, 4, 2],
  [4, 1, 5, 2],
  [3, 2, 5, 3],
  [5, 1, 7, 2],
  [5, 2, 6, 3],
  [6, 2, 7, 3],
];

const rowsPerBlock = 6;

document.querySelectorAll('.inspiration-list__item').forEach((item, i) => {
  const block = Math.floor(i / 7);
  const index = i % 7;
  const [r1, c1, r2, c2] = pattern[index];

  const rowStart = r1 + rowsPerBlock * block;
  const rowEnd = r2 + rowsPerBlock * block;
  item.style.gridArea = `${rowStart} / ${c1} / ${rowEnd} / ${c2}`;
});
